import { render } from "./CenteredText.vue?vue&type=template&id=0b3100a2"
import script from "./CenteredText.vue?vue&type=script&lang=js"
export * from "./CenteredText.vue?vue&type=script&lang=js"
script.render = render

export default script